(function () {
    'use strict';
    
    angular
    .module('szallodak-dailyprice', ['daterangepicker']);
})();
